import { useEffect, useState } from "react";

export default function Profile() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teamDetails, setTeamDetails] = useState(null);
  const [loadingTeam, setLoadingTeam] = useState(false);

  useEffect(() => {
    fetch('http://localhost:3007/api/registration', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': window.localStorage.getItem('authToken')
      }
    })
      .then(res => res.json())
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const fetchTeamDetails = async (registrationId) => {
    setLoadingTeam(true);
    try {
      const res = await fetch(`http://localhost:3007/api/registration/${registrationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': window.localStorage.getItem('authToken')
        }
      });
      const data = await res.json();
      console.log(data);
      setTeamDetails(data);
    } catch (err) {
      console.log(err);
    }
    setLoadingTeam(false);
  };

  const groupedGames = {
    individual: data.filter(game => !game.isTeam),
    team: data.filter(game => game.isTeam)
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 overflow-hidden">
      <div className="container mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <h1 className="text-4xl pb-1 md:text-5xl font-bold bg-gradient-to-b from-[#190003] to-red-500 bg-clip-text text-transparent">
            My Registered Games
          </h1>
          <p className="text-red-400 mt-2">
            Total Registrations: {data.length}
          </p>
        </div>

        {/* Individual Games Section */}
        {groupedGames.individual.length > 0 && (
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mr-2 text-red-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Individual Games
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {groupedGames.individual.map((game) => (
                <div
                  key={game.id}
                  className="bg-gradient-to-b from-[#190003] to-red-500 rounded-lg p-6 text-white shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-xl font-bold">{game.game}</h3>
                    <span className="bg-white/20 px-2 py-1 rounded-full text-xs">
                      Individual
                    </span>
                  </div>
                  <div className="text-white/80 text-sm">
                    Registration ID: {game.id.slice(0, 8)}...
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Team Games Section */}
        {groupedGames.team.length > 0 && (
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mr-2 text-red-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              Team Games
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {groupedGames.team.map((game) => (
                <div
                  key={game.id}
                  className="bg-gradient-to-b from-[#190003] to-red-500 rounded-lg p-6 text-white shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                  onClick={() => {
                    setSelectedTeam(game);
                    fetchTeamDetails(game.id);
                  }}
                >
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-xl font-bold">{game.game}</h3>
                    <span className="bg-white/20 px-2 py-1 rounded-full text-xs">
                      Team
                    </span>
                  </div>
                  <div className="text-white/80 text-sm">
                    Registration ID: {game.id.slice(0, 8)}...
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {data.length === 0 && (
          <div className="text-center py-12">
            <div className="text-gray-500 text-lg">
              You haven't registered for any games yet.
            </div>
          </div>
        )}
      </div>

      {/* Team Details Modal */}
      {selectedTeam && (
  <div className="fixed inset-0 z-999 flex items-center justify-center p-4 bg-black/50 overflow-hidden">
    <div className="bg-white rounded-lg w-full max-w-2xl shadow-xl overflow-auto">
      <div className="rounded-t-lg p-6 text-red-500">
        <div className="flex justify-between items-center">
          <h3 className="text-2xl font-bold">{selectedTeam.game} Team Details</h3>
          <button
            onClick={() => {
              setSelectedTeam(null);
              setTeamDetails(null);
            }}
            className="text-white/80 hover:text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 bg-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Modal Content with Fixed Height */}
      <div className="p-6 max-h-[70vh] overflow-y-auto">
        {loadingTeam ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500"></div>
          </div>
        ) : teamDetails ? (
          <div className="space-y-6">
            <div className="grid gap-6">
              {teamDetails.players.map((player, index) => (
                <div
                  key={player.id}
                  className="bg-gray-50 rounded-lg p-4 border border-red-100"
                >
                  <div className="flex items-center gap-4">
                    <div className="bg-gradient-to-b from-[#190003] to-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">
                      {index + 1}
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-gray-900">{player.name}</h4>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-2 text-sm text-gray-600">
                        <div>Enrollment: {player.enrollmentNumber}</div>
                        <div>T-Shirt: {player.tShirtSize}</div>
                        <div>Semester: {player.semester}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            Failed to load team details. Please try again.
          </div>
        )}
      </div>
    </div>
  </div>
)}

    </div>
  );
}

